export enum DashboardLabelName {
  NewInquiry = 'new inquiry',
  Prequalified = 'Prequalified',
  Processing = 'processing',
  Underwriting = 'underwriting',
  Approved = 'approved',
  Funded = 'funded',
  Denied = 'denied',
  Declined = 'declined',
}
